import { Component } from 'react';
import CheckboxGroup from '../CheckboxGroup'
import { validator } from 'Helpers/validator';
import validation from 'Helpers/Validation';
import LoadingOverlay from 'react-loading-overlay';
import { ModuleActions } from 'Constants/Modules.constants';

class AddManageAdminRoles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      module:'',
      roleName: '',
      errorElement:'',
      allowerModulesError: '',
      allowedModulesErrorMessage: 'Please grant access to at least one role.',
    }
    this.validator = validator.getInstance();
  }

  /**
   * @method validation
   * @summary validate the inputs based on validation rules
   * @param {event} event - React onBlur event
   * @return {none} undefined
   */
  componentDidMount(){
    this.setState({ module:this.props.allowedModules })
  }
  validation = e => {
    validation(e, 'addroleform');
  };

  closeaddroles = () => {
      this.props.closeAddRoles()
  };

  onCheckboxGroupChange = (checkboxGroupkey, checkboxes) => {
    this.setState(prevState => ({
      ...prevState,
      module: {
        ...prevState.module,
        [ checkboxGroupkey ]: checkboxes
      }
    }))
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [ name ]: value });
  }
  
  createcheckBoxGroup = () => {
    var checkboxGroupArray = [];
    for (const property in this.state.module) {
      const cb = this.state.module[ property ];
      const isChecked = Object.keys(cb).some(key => cb[ key ]);
      cb[ ModuleActions.view ] = isChecked;
      checkboxGroupArray.push(<CheckboxGroup
            checkboxes={ this.state.module[ property ] }
            checkboxGroupkey={ property } 
            parentClass = 'addroles'
            key={ property }
            onCheckboxGroupChange={ this.onCheckboxGroupChange }
      />)
    }
    return checkboxGroupArray
  }

  isOneChecked = () => {
    const radio = document.getElementsByTagName('input');
    for (let i = 0; i < radio.length; i++) {
      if (radio[ i ].type == 'checkbox' && radio[ i ].checked) {
        return true
      } 
    }
    return false
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const { id } = event.target;
    this.setState({
      allowerModulesError: this.isOneChecked() ? '' : this.state.allowedModulesErrorMessage
    }, () => {
      if( id && !this.validator.checkBeforeSubmit(id) && this.state.allowerModulesError === '' ) {
        const data = { ...this.state, isDeletable:1 }
        this.props.addAdminRoles(data,this.props.filterVal);       
      }
    });
  }
  
  componentDidUpdate(prevProps, prevState) {
      if(prevProps.totalRecords !== this.props.totalRecords) {
           if( this.props.error !== true && this.props.errorElement === '' ) {        
             document.getElementById('searchForm') && 
             document.getElementById('searchForm').reset();
             this.closeaddroles();
          } 
      }  
      if (prevProps.errorElement !== this.props.errorElement) {
        this.setState({ errorElement:this.props.errorElement })
      }   
    }

  render() {
    const { roleName, errorElement, allowerModulesError } = this.state;
    const { formLoading } = this.props
    return (
      <>
        <div className='addadmin' id='addroles'>
          <div className='overlay' onClick={ this.props.closeaddroles }></div>
          <div className='addadminroles'>
          <LoadingOverlay
            active={ formLoading }
            spinner
            styles={ {
              wrapper: {
                width: '100%',
                textAlign: '-webkit-center'
              }
            } }
            text='Please wait...'
          ></LoadingOverlay>
            <div className='head'>
              <h2>Add Roles</h2>
            </div>
            <form id='addroleform' autoComplete='off' onSubmit={ this.handleSubmit }>
              <div className='ctInputField'>
                <label>
                  Role<sup>*</sup>
                </label>
                <input id="roleName"
                  onChange={ this.handleChange }
                  value={ roleName }
                  type="text"
                  name="roleName"
                  data-length={ 50 }
                  onBlur={ this.validation }
                  data-validation={ [ 'requiredfield,maxlength' ] }
                  data-error= 'Enter valid role name'
                  placeholder="Enter role here!" />
              </div>
              <div className='allowedmodules'>
                <h3>Allowed Modules</h3>
                { allowerModulesError && <span id="allowedModules-requiredfield" className="error">{ allowerModulesError }</span> }
                <div className='allroles'>
                     {this.createcheckBoxGroup()}
                </div>
              </div>
              { errorElement !== '' && 
                    <span className='errorElement'>{ errorElement }</span> }
              <div className='buttons'>
                <div>
                  <button type='reset' onClick={ this.closeaddroles } className='btn btn_outline'>Cancel</button>
                  <button type='submit' className='btn btn_primary'>Save</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </>
    );
  }
}

export default AddManageAdminRoles;
